/**
 * Business inbox count summary (L3-NOTIF-v2 · UA-V2-3)
 *
 * Single fetch on active assignments → approval pending + dispatch queue counts.
 * Reuses client-side heuristics from flowApprovalsQueue · flowDispatchQueue.
 */

import type { TaskAssignment } from '@shared/flow/task-assignment-types';
import { filterApprovalPendingAssignments } from './flowApprovalsQueue';
import { filterDispatchQueueAssignments } from './flowDispatchQueue';

export interface FlowAssignmentRowLike {
  flowId: string;
  status?: string;
  assigneeRole?: TaskAssignment['assigneeRole'];
  tags?: string[];
  name?: string;
}

export interface BusinessInboxCounts {
  approvalPending: number;
  dispatch: number;
  total: number;
}

export function parseFlowAssignmentRows(payload: unknown): FlowAssignmentRowLike[] {
  if (!payload || typeof payload !== 'object') return [];
  const data = payload as {
    assignments?: FlowAssignmentRowLike[];
    data?: { assignments?: FlowAssignmentRowLike[] };
  };
  if (Array.isArray(data.assignments)) return data.assignments;
  if (Array.isArray(data.data?.assignments)) return data.data.assignments;
  if (Array.isArray(payload)) return payload as FlowAssignmentRowLike[];
  return [];
}

export function summarizeBusinessInboxCounts(rows: FlowAssignmentRowLike[]): BusinessInboxCounts {
  const approvalPending = filterApprovalPendingAssignments(rows).length;
  const dispatch = filterDispatchQueueAssignments(rows).length;
  return {
    approvalPending,
    dispatch,
    total: approvalPending + dispatch,
  };
}
